import { Mail, Phone } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import XIcon from './icons/XIcon';
import FacebookIcon from './icons/FacebookIcon';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.about.title')}</h3>
            <p className="text-gray-600">
              {t('footer.about.description')}
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.legal.title')}</h3>
            <ul className="space-y-2">
              <li><a href="/imprint" className="text-gray-600 hover:text-blue-600">{t('footer.legal.imprint')}</a></li>
              <li><a href="/privacy" className="text-gray-600 hover:text-blue-600">{t('footer.legal.privacy')}</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.contact.title')}</h3>
            <ul className="space-y-2">
              <li className="flex items-center">
                <Mail className="h-5 w-5 mr-2" />
                <a href="mailto:info@simons-marketing-solutions.com" className="text-gray-600 hover:text-blue-600">
                  info@simons-marketing-solutions.com
                </a>
              </li>
              <li className="flex items-center">
                <Phone className="h-5 w-5 mr-2" />
                <a href="tel:+491762493841" className="text-gray-600 hover:text-blue-600">
                  +49 (0) 176 24938417
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.social.title')}</h3>
            <div className="flex space-x-4">
              <a href="https://x.com/SimonsMarketSol" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue-600">
                <XIcon className="h-6 w-6" />
              </a>
              <a href="https://www.facebook.com/profile.php?id=61560457171931" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue-600">
                <FacebookIcon className="h-6 w-6" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-200">
          <p className="text-center text-gray-500">
            © {new Date().getFullYear()} {t('footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
